export const COMPANY_LEGAL_NAME = 'PLATAFORMA DIGITAL YOC SAPI DE CV'

export const COMPANY_BANK_ACCOUNT = Object.freeze({
  bankName: 'Santander',
  accountNumber: '65-50969732-6',
  clabe: '014580655096973264',
  card: '5579 0890 0447 7553',
  name: COMPANY_LEGAL_NAME,
})

export default { COMPANY_LEGAL_NAME, COMPANY_BANK_ACCOUNT }
